import axios from "@/libs/axios";
import { ref } from "@vue/composition-api";

export default function useTags() {
    const tags = ref([]);
    const fetchTags = () => {
        axios.get("tags").then((result) => (tags.value = result.data));
    };

    return {
        tags,
        fetchTags,
    };
}
